export default [
    {
        name: 'userReset',
        path: '/user/reset',
        component: require('@/pages/UserResetPassword').default,
    },
    {
        name: 'resetConfirm', // NB: this name is used in User.checkAuth() to whitelist the route
        path: '/user/:email/reset/confirm/:confirm',
        component: require('@/pages/UserResetPassword').default,
    },
    {
        name: 'userList',
        path: '/user/list/:relation?/:id?',
        component: require('@/pages/UserList').default,
        props: (route) => ({
            relation: route.params.relation,
            id: +route.params.id
        }),
        meta: {
            back: { label: 'Dashboard', to: '/' },
            // security: (auth) => {
            //     if (auth.to.params.relation) {
            //         return auth.can({
            //             action: 'list',
            //             model: 'user/' + auth.to.params.relation, // e.g. 'user/agency'
            //             arg: +auth.to.params.id
            //         })
            //     } else {
            //         return auth.can({ action: 'list', model: 'user' })
            //     }
            // }
        }
    },
    {
        name: 'userView',
        path: '/user/view/:userId',
        component: require('@/pages/UserView').default,
        props: (route) => ({
            userId: +route.params.userId,
        }),
        meta: {
            back: { label: 'User List', to: '/user/list' },
            security: (auth) => auth.can({ action: 'view', model: 'user', arg: +auth.to.params.userId })
        }
    },
    {
        name: 'userEdit',
        path: '/user/edit/:userId',
        component: require('@/pages/UserEdit').default,
        props: (route) => ({
            userId: +route.params.userId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', arg: +auth.to.params.userId })
        }
    },
    {
        name: 'userPassword',
        path: '/user/password/:userId',
        component: require('@/pages/UserPassword').default,
        props: (route) => ({
            userId: +route.params.userId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', arg: +auth.to.params.userId })
        }
    },
    {
        name: 'userCreate',
        path: '/user/create',
        component: require('@/pages/UserCreate').default,
        meta: {
            back: { label: 'Login', to: '/' },
        }
    },
    {
        name: 'userActivate',
        path: '/user/create/:activate_key',
        component: require('@/pages/UserCreate').default,
        props: (route) => ({
            activate_key: route.params.activate_key
        })
    },
    {
        name: 'userCreateByEmail',
        path: '/user/create/email/:email',
        component: require('@/pages/UserCreate').default,
        props: (route) => ({
            email: route.params.email
        })
    },
    {
        name: 'userAgencyCreate',
        path: '/user/view/:userId/agency/create',
        component: require('@/pages/UserAgencyCreate').default,
        props: (route) => ({
            userId: +route.params.userId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', args: +auth.to.params.userId })
        }
    },
    {
        name: 'userAgencyEdit',
        path: '/user/view/:userId/agency/:agencyUserId/edit',
        component: require('@/pages/UserAgencyEdit').default,
        props: (route) => ({
            userId: +route.params.userId,
            agencyUserId: +route.params.agencyUserId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', args: +auth.to.params.userId })
        }
    },
    {
        name: 'userCompanyCreate',
        path: '/user/view/:userId/company/create',
        component: require('@/pages/UserCompanyCreate').default,
        props: (route) => ({
            userId: +route.params.userId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', args: +auth.to.params.userId })
        }
    },
    {
        name: 'userCompanyEdit',
        path: '/user/view/:userId/company/:companyUserId/edit',
        component: require('@/pages/UserCompanyEdit').default,
        props: (route) => ({
            userId: +route.params.userId,
            companyUserId: +route.params.companyUserId,
        }),
        meta: {
            back: { label: ':userName', to: '/user/view/:userId' },
            security: (auth) => auth.can({ action: 'edit', model: 'user', args: +auth.to.params.userId })
        }
    },
    {
        name: 'userEmailActivate',
        path: '/user/:email/create/:role/:activate_key',
        component: require('@/pages/UserCreate').default,
        props: (route) => ({
            email: route.params.email,
            activate_key: route.params.activate_key,
            role: route.params.role,
        })
    },
]
